<script setup lang="ts">
import { useStore } from '@nanostores/vue'
import BaseButton from '@/components/ui/button/BaseButton.vue'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { isLogin } from '@/store/userStore'
import { getMcrRootUrl, getSiteBaseMemberPath } from '@/lib/siteBaseUrl'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import { getCurrentGaPageName } from '@/lib/utils'

interface Props {
	footer: {
		title: string
		subtitle: string
		buttonText: string
	}
	theme: 'shopping' | 'shipping'
}

const props = defineProps<Props>()

const isLoginGlobal = useStore(isLogin)

const handleGetStartedClick = () => {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: getCurrentGaPageName(),
		button_name: 'Get Started - Bottom',
	})

	const targetUrlObject = {
		shopping: {
			beforeLogin: `${getSiteBaseMemberPath()}/buyforyou/new`,
			afterLogin: `${getMcrRootUrl()}/buyforyou/new`,
		},
		shipping: {
			beforeLogin: `${getSiteBaseMemberPath()}/shipments/new`,
			afterLogin: `${getMcrRootUrl()}/shipments/new`,
		},
	}

	const targetUrl = isLoginGlobal.value
		? targetUrlObject[props.theme].afterLogin
		: targetUrlObject[props.theme].beforeLogin

	if (isLoginGlobal.value) {
		window.location.href = targetUrl
	} else {
		window.BsHeaderVm.showPanel('signup')

		const url = new URL(window.location.href)
		url.searchParams.set('redirect', targetUrl)
		window.history.pushState({}, '', url)
	}
}
</script>

<template>
	<section class="relative overflow-hidden rounded-xl bg-t-900 p-acquaintances">
		<!-- orange -->
		<div
			class="absolute top-0 hidden h-[292px] w-[164px] mdp:right-[-2.5%] mdp:block lg:right-0"
		>
			<BaseIcon
				name="shipment_protection_footer_orange"
				class="h-[292px] w-[164px]"
			/>
		</div>

		<!-- teal -->
		<div
			class="absolute top-0 hidden h-[292px] w-[164px] mdp:left-[-2.5%] mdp:block lg:left-0"
		>
			<BaseIcon
				class="h-[292px] w-[164px]"
				name="shipment_protection_footer_teal"
			/>
		</div>

		<div class="relative z-10">
			<div
				class="flex flex-col items-center justify-center gap-16px text-center"
			>
				<h2 class="typography-h2-str text-white">
					{{ props.footer.title }}
				</h2>

				<p class="typography-b2-reg text-white">
					{{ props.footer.subtitle }}
				</p>

				<BaseButton
					variant="primary"
					size="large"
					@click="handleGetStartedClick"
					class="mt-8px"
				>
					{{ props.footer.buttonText }}
				</BaseButton>
			</div>
		</div>
	</section>
</template>
